<template>
    <div class="contact-info">
        <div class="info-row">
            <img :src="`${rootPath}/static/icons/pointer.png`" alt="address"></img>
            <span>{{ model.address }}</span>
        </div>
        <div class="info-row" v-if="model.collectionDateStart">
            <img :src="`${rootPath}/static/icons/tree.png`" alt="collection"></img>
            <span v-if="model.collectionDateEnd"> {{
                model.translations["hospice.Contact.CollectionOpenAndCloseDate"] }}
                <span class="date">{{ longLocalDate(culture, model.collectionDateStart) }}</span> -
                <span class="date">{{ longLocalDate(culture, model.collectionDateEnd) }}</span></span>
            <span v-else class="date"> {{ model.translations["hospice.Contact.CollectionOnlyOpenDate"] }}
                {{ longLocalDate(culture, model.collectionDateStart) }}</span>
        </div>
        <a class="info-row" target="_blank" v-if="model.website" :href="model.website.url">
            <img :src="`${rootPath}/static/icons/link.png`" alt="link"></img>
            <span>{{ model.website.text }}</span>
        </a>
    </div>
</template>
<script setup lang="ts">
import { longLocalDate } from '@/share/util';
import { IHospiceContactProps } from './HospiceContact.model';

const { model } = defineProps<IHospiceContactProps>()
const culture = window.__STATE__?.culture ?? "en-GB"
const rootPath = window.__STATE__?.rootPath
</script>
<style lang="scss" scoped>
.contact-info {
    display: flex;
    flex-direction: column;
    gap: 10px;

    margin-top: auto;
    padding-bottom: 20px;
}

.info-row {
    display: flex;
    gap: 5px;
    align-items: center;

    img {
        width: 32px;
        aspect-ratio: 1/1;
    }

    a {
        color: var(--primary)
    }
}

.date {
    font-weight: 700;
}

@media (min-width: 768px) {
    .carousel-container {
        min-height: 450px;
    }
}
</style>